;(() => {
  const initDisclosure = (disclosure) => {
    if (disclosure.dataset.initialized === 'true') return

    const toggle = disclosure.querySelector('[data-disclosure-toggle]')
    const list = disclosure.querySelector('[data-disclosure-list]')
    const input = disclosure.querySelector('[data-disclosure-input]')
    const form = disclosure.closest('form')

    if (!toggle || !list || !input || !form) return

    const close = () => {
      toggle.setAttribute('aria-expanded', 'false')
      list.setAttribute('aria-hidden', 'true')
      list.classList.add('hidden')
    }

    toggle.addEventListener('click', () => {
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true'
      document.querySelectorAll('[data-disclosure][data-initialized="true"]').forEach((item) => {
        if (item !== disclosure) {
          item.querySelector('[data-disclosure-toggle]')?.setAttribute('aria-expanded', 'false')
          item.querySelector('[data-disclosure-list]')?.setAttribute('aria-hidden', 'true')
          item.querySelector('[data-disclosure-list]')?.classList.add('hidden')
        }
      })
      toggle.setAttribute('aria-expanded', String(willOpen))
      list.setAttribute('aria-hidden', String(!willOpen))
      list.classList.toggle('hidden', !willOpen)
    })

    list.querySelectorAll('[data-disclosure-option]').forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault()
        input.value = option.dataset.value
        close()
        form.submit()
      })
    })

    document.addEventListener('click', (event) => {
      if (!disclosure.contains(event.target)) close()
    })

    disclosure.dataset.initialized = 'true'
    close()
  }

  const initNewsletterKlaviyo = (container) => {
    if (!container || container.dataset.initialized === 'true') return

    const formElement = container.querySelector('form')
    const emailField = container.querySelector('input[type="email"]')
    const listId = container.dataset.listId
    const publicKey = container.dataset.publicKey

    if (!formElement || !emailField || !listId || !publicKey) return

    const setState = (state) => {
      container.classList.remove('success', 'error', 'error-email')
      if (state) container.classList.add(state)
    }

    formElement.addEventListener('submit', async (event) => {
      event.preventDefault()
      const email = emailField.value
      const isValid =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email
        )

      if (!isValid) {
        setState('error-email')
        return
      }

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${publicKey}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2024-06-15',
              'cache-control': 'no-cache',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: listId } } },
              },
            }),
          }
        )

        if (response.ok) {
          setState('success')
          if (window.oneskin && window.oneskin.events) {
            window.oneskin.events.track('newsletter_signup', { source_location: 'footer' })
          }
        } else setState('error')
      } catch (error) {
        console.log('The subscription marketing list was unsuccessful due to an error:', error)
        setState('error')
      }
    })

    container.dataset.initialized = 'true'
  }

  const initFooter = (footer) => {
    if (footer.dataset.initialized === 'true') return

    footer.querySelectorAll('[data-disclosure]').forEach(initDisclosure)
    footer.querySelectorAll('[data-newsletter-klaviyo]').forEach(initNewsletterKlaviyo)
    footer.dataset.initialized = 'true'
  }

  const initFooters = (root = document) => {
    root.querySelectorAll('[data-section-type="footer"]').forEach(initFooter)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFooters())
  } else {
    initFooters()
  }

  document.addEventListener('shopify:section:load', (event) => initFooters(event.target))
})()
